import { render, staticRenderFns } from "./RunnitTagTypeSelect.vue?vue&type=template&id=b5887000&scoped=true"
import script from "./RunnitTagTypeSelect.vue?vue&type=script&lang=ts"
export * from "./RunnitTagTypeSelect.vue?vue&type=script&lang=ts"
import style0 from "./RunnitTagTypeSelect.vue?vue&type=style&index=0&id=b5887000&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5887000",
  null
  
)

export default component.exports